import React from 'react';
import { ChevronDown } from 'lucide-react';
import { cn } from '../../lib/cn';

const Select = React.forwardRef(function Select(
  { className, selectClassName, error = false, children, ...rest },
  ref
) {
  return (
    <div className={cn('relative w-full', className)}>
      <select
        ref={ref}
        className={cn(
          'appearance-none w-full h-9 pl-3 pr-8 text-sm bg-white border rounded-md shadow-soft text-slate-900',
          'transition-colors duration-150',
          'focus:outline-none focus:ring-2',
          error
            ? 'border-rose-300 focus:border-rose-500 focus:ring-rose-100'
            : 'border-slate-200 focus:border-brand-500 focus:ring-brand-100',
          selectClassName
        )}
        {...rest}
      >
        {children}
      </select>
      <ChevronDown className="absolute right-2.5 top-1/2 -translate-y-1/2 h-3.5 w-3.5 text-slate-400 pointer-events-none" />
    </div>
  );
});

export default Select;
